import { useState } from "react";
import { usePortfolioImages } from "@/hooks/usePortfolio";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ImageIcon } from "lucide-react";

const PortfolioGallery = ({ userId }: { userId: string }) => {
  const { data: images = [], isLoading } = usePortfolioImages(userId);
  const [selected, setSelected] = useState<string | null>(null);

  if (isLoading || images.length === 0) return null;

  return (
    <div>
      <h2 className="mb-3 font-display text-lg font-semibold flex items-center gap-2">
        <ImageIcon className="h-5 w-5" />
        Portfolio ({images.length})
      </h2>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {images.map((img) => (
          <button
            key={img.id}
            className="group relative aspect-square overflow-hidden rounded-lg border bg-muted cursor-pointer"
            onClick={() => setSelected(img.image_url)}
          >
            <img
              src={img.image_url}
              alt={img.caption || "Réalisation"}
              className="h-full w-full object-cover transition-transform group-hover:scale-105"
            />
            {img.caption && (
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2">
                <p className="text-xs text-white truncate">{img.caption}</p>
              </div>
            )}
          </button>
        ))}
      </div>

      <Dialog open={!!selected} onOpenChange={() => setSelected(null)}>
        <DialogContent className="max-w-3xl p-1">
          {selected && (
            <img src={selected} alt="Portfolio" className="w-full rounded-lg" />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PortfolioGallery;
